module.exports = __webpack_public_path__ + "img/lt-background-phone-violet.0a76a955.png";